import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=15d840c6&scoped=true"
import script from "./statistic.vue?vue&type=script&lang=js"
export * from "./statistic.vue?vue&type=script&lang=js"
import style0 from "./statistic.vue?vue&type=style&index=0&id=15d840c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d840c6",
  null
  
)

export default component.exports